// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".youtubeembed-module_youtubeembed_a8fOyBUHzEFDNKoVftvf iframe{max-width:100%}", "",{"version":3,"sources":["webpack://./src/bloks/articlepanels/youtubeembed/youtubeembed.module.scss"],"names":[],"mappings":"AACA,8DACE,cAAA","sourcesContent":["@import \"src/styles/theme.scss\";@import \"~cx-web-themes/crunchyroll/abstracts/main\";\n.youtubeembed iframe {\n  max-width: 100%;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"youtubeembed": "youtubeembed-module_youtubeembed_a8fOyBUHzEFDNKoVftvf"
};
export default ___CSS_LOADER_EXPORT___;
